import { CoreUserAgent } from "../UserAgent";
import { CoreBaseLoader } from "./_Base";
export var GeometryFormat = /* @__PURE__ */ ((GeometryFormat2) => {
  GeometryFormat2["AUTO"] = "auto";
  GeometryFormat2["JSON"] = "json";
  return GeometryFormat2;
})(GeometryFormat || {});
export const GEOMETRY_FORMATS = ["auto" /* AUTO */, "json" /* JSON */];
export var GeometryExtension = /* @__PURE__ */ ((GeometryExtension2) => {
  GeometryExtension2["DRC"] = "drc";
  GeometryExtension2["FBX"] = "fbx";
  GeometryExtension2["GLTF"] = "gltf";
  GeometryExtension2["GLB"] = "glb";
  GeometryExtension2["JSON"] = "json";
  GeometryExtension2["MPD"] = "mpd";
  GeometryExtension2["OBJ"] = "obj";
  GeometryExtension2["PDB"] = "pdb";
  GeometryExtension2["PLY"] = "ply";
  GeometryExtension2["STL"] = "stl";
  GeometryExtension2["SVG"] = "svg";
  return GeometryExtension2;
})(GeometryExtension || {});
export const GEOMETRY_EXTENSIONS = [
  "drc" /* DRC */,
  "fbx" /* FBX */,
  "gltf" /* GLTF */,
  "glb" /* GLB */,
  "json" /* JSON */,
  "mpd" /* MPD */,
  "obj" /* OBJ */,
  "pdb" /* PDB */,
  "ply" /* PLY */,
  "stl" /* STL */
];
const _CoreLoaderGeometry = class extends CoreBaseLoader {
  constructor(_options, _node) {
    super(_options.url, _node);
    this._options = _options;
    this._node = _node;
  }
  static setMaxConcurrentLoadsCount(method) {
    this._maxConcurrentLoadsCountMethod = method;
  }
  static _initMaxConcurrentLoadsCount() {
    if (this._maxConcurrentLoadsCountMethod) {
      return this._maxConcurrentLoadsCountMethod();
    }
    return CoreUserAgent.isChrome() ? 4 : 1;
  }
  static _initConcurrentLoadsDelay() {
    return CoreUserAgent.isChrome() ? 1 : 10;
  }
  static incrementInProgressLoadsCount() {
    this._inProgressLoadsCount++;
  }
  static decrementInProgressLoadsCount() {
    this._inProgressLoadsCount--;
    const queued_resolve = this._queue.pop();
    if (queued_resolve) {
      const delay = this.CONCURRENT_LOADS_DELAY;
      setTimeout(() => {
        queued_resolve();
      }, delay);
    }
  }
  static async waitForMaxConcurrentLoadsQueueFreed() {
    if (this._inProgressLoadsCount <= this.MAX_CONCURRENT_LOADS_COUNT) {
      return;
    } else {
      return new Promise((resolve) => {
        this._queue.push(resolve);
      });
    }
  }
};
export let CoreLoaderGeometry = _CoreLoaderGeometry;
CoreLoaderGeometry.MAX_CONCURRENT_LOADS_COUNT = _CoreLoaderGeometry._initMaxConcurrentLoadsCount();
CoreLoaderGeometry.CONCURRENT_LOADS_DELAY = _CoreLoaderGeometry._initConcurrentLoadsDelay();
CoreLoaderGeometry._inProgressLoadsCount = 0;
CoreLoaderGeometry._queue = [];
